import React from 'react';

import { Box } from '@/components/lib/components';
import { Handle, MODAL_HANDLE_HEIGHT } from '@/feature/alerts/components/Modal';
import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { CircularPagerSheetHandleGestureWrapper } from '@/feature/circular-pager/BottomSheetCircularPagerWrapper';
import { EVENT_SHEET_TITLE_HEIGHT } from '@/feature/fantasy-event-sheets/components/EventSheetTitle';
import { PlayerProfileTitle } from '@/feature/player-profile-sheets/components/PlayerProfileTitle';
import { common, designSystem, withOpacity } from '@/styles/styles';

export const PlayerProfileSheetHandle = ({ playerInfo }: { playerInfo: PlayerWithTeamAndEvent }) => {
    return (
        <CircularPagerSheetHandleGestureWrapper>
            <Box
                position={'absolute'}
                zIndex={1}
                width={'100%'}
                height={EVENT_SHEET_TITLE_HEIGHT + MODAL_HANDLE_HEIGHT}
                overflow={'hidden'}
                borderTopLeftRadius={'r16'}
                borderTopRightRadius={'r16'}
            >
                <Box style={common.flex}>
                    <Handle
                        handleColor={withOpacity(designSystem.colors.white, 0.15)}
                        handleContainerStyle={common.backgroundColorTransparent}
                    />
                    <PlayerProfileTitle playerInfo={playerInfo} />
                </Box>
            </Box>
        </CircularPagerSheetHandleGestureWrapper>
    );
};
